module.exports = __webpack_public_path__ + "static/media/pointer.ba78b77f.ba78b77f.png";